<template>
    <div id="app">
        <div v-show="showLogin" class="app-login-box">
            <div @click.self.prevent="closeLogin" class="login-mask"></div>
            <div id="loginIn"></div>
        </div>
        <router-view/>
    </div>
</template>

<style lang="less" scoped>
.app-login-box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 6666;
}

.login-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
    z-index: 7777;
}

#loginIn {
    position: absolute;
    z-index: 9999;
}
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    computed: {
        ...mapGetters(['showLogin'])
    },
    created () {
        // window.onbeforeunload = function (event) {
        //     event.preventDefault();
        // }
    },
    beforeDestroy () {
    },
    methods: {
        ...mapMutations(['setShowLogin']),
        closeLogin () {
            instance._toggleShow(false)
            this.setShowLogin(false)
        },
    }
}
</script>
